import React, { useCallback, useState } from 'react'

import {Grid, CircularProgress} from '@mui/material'
import { useSelector } from 'react-redux'

import useStyles from './styles.js'

import Team from './team/Team.js'
import { useFilters } from '../../filters/useFilters.js'
import Select_Dsas from '../../dsasComponents/Select_Dsas.js'
import { discipline_all, getActualSeason, season_all } from '../../bdd/bddSTUB.js'
import { isAdminDSAS } from '../../actions/auth.js'
import FilterGroupProvider from '../../dsasComponents/FilterGroupProvider.js'
import { fetchCompetitions, fetchTeams } from '../../api/index.js'
import { useFetch } from '../../filters/useFetch.js'
import { reload } from '../../filters/reload.js'
import { FETCH_ALL_COMPETITION, FETCH_ALL_TEAM } from '../../constants/actionTypes.js'
import Pagination from '../../dsasComponents/pagination/Pagination.js'

const Teams = ( { setCurrentId }) => {
    const classes = useStyles();

    const [filters, setFilters] = useState({discipline : '', competition : '', provider : '', season : getActualSeason()})

    const [teams, loading] = useFetch(fetchTeams, filters, ['competition'], FETCH_ALL_TEAM)

    const [competitions, loadingCompetition] = useFetch(fetchCompetitions, filters, undefined, FETCH_ALL_COMPETITION)


    return (
        loading ? <CircularProgress /> : (<>
        <div>
        {isAdminDSAS() && <FilterGroupProvider
                        classname={classes.customInput}
                        labelId = {"provider_label"}
                        label = {"Groupe"}
                        selectId = {"provider"}
                        name = {"provider"}
                        filters = {filters} 
                        setFilters = {setFilters}
                    />}
                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"discipline_label"}
                            label = {"Discipline"}
                            selectId = {"discipline"}
                            name = {"discipline"}
                            value = {filters.discipline}
                            items = {discipline_all}
                            onChange = {(e) => setFilters(state => ({...state, discipline : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, discipline : ''}))}
                />

                <Select_Dsas
                            className={classes.selectInput}
                            labelId = {"season_label"}
                            label = {"Saison"}
                            selectId = {"season"}
                            name = {"season"}
                            value = {filters.season}
                            items = {season_all}
                            onChange = {(e) => setFilters(state => ({...state, season : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, season : ''}))}
                />

                {loadingCompetition ?<CircularProgress /> :  <Select_Dsas
                            isError = {!filters.competition}
                            className={classes.selectInput}
                            labelId = {"competition_label"}
                            label = {"Compétition"}
                            selectId = {"competition"}
                            name = {"competition"}
                            value = {filters.competition}
                            items = {competitions}
                            onChange = {(e) => setFilters(state => ({...state, competition : e.target.value}))}
                            onReset = {(e) => setFilters(state => ({...state, competition : ''}))}
                />}

            </div>

            <Pagination items={teams} classes={classes}>
                {teams.map(team => 
                    <Team team={team} setCurrentId={setCurrentId} reload={() => reload(setFilters)}/>
                )}
            </Pagination></>
        )
    )
}

export default Teams